<script setup lang="ts">
import { Button, Popover } from "@soft-db/ui";

const props = defineProps<{
	disabled?: boolean;
	showDelete?: boolean;
	onDelete?: (_: MouseEvent) => void;
}>();

const emit = defineEmits({
	update: (_file: File) => true,
	delete: () => true,
});

defineOptions({ inheritAttrs: false });

const { t } = useI18n();

const open = ref(false);

const fileInput = useTemplateRef("fileInput");

const chooseFile = () => {
	if (fileInput.value) fileInput.value.click();
	open.value = false;
};

function uploadFile() {
	if (fileInput.value) {
		const files = fileInput.value.files;
		if (files) {
			emit("update", files[0]);
		}
	}
}
function deleteFile() {
	open.value = false;
	emit("delete");
}

function openMenu() {
	if (!props.onDelete) {
		chooseFile();
	} else {
		open.value = true;
	}
}
</script>

<template>
	<Popover v-model:open="open" followCursor align="start" :offset="4">
		<template #trigger>
			<button
				class="group relative overflow-hidden"
				:class="disabled ? 'cursor-not-allowed' : ''"
				:disabled="disabled"
				type="button"
				v-bind="$attrs"
				@click="openMenu"
			>
				<div
					v-if="!disabled"
					class="z-1 absolute size-full bg-gray-100/40 opacity-0 transition-opacity group-hover:opacity-100"
				/>
				<slot />
				<input
					ref="fileInput"
					type="file"
					accept="image/png, image/jpeg"
					hidden
					@change="uploadFile"
				/>
			</button>
		</template>
		<template #default>
			<div class="join join-vertical flex flex-col">
				<Button class="join-item" @click="chooseFile">
					{{ t("common.uploadImage") }}
				</Button>
				<Button v-if="showDelete" class="join-item" @click="deleteFile">
					{{ t("common.deleteImage") }}
				</Button>
			</div>
		</template>
	</Popover>
</template>
